import CryptoJS from "crypto-js";
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

const encryptPassword = (password) => {
  const encrypted = CryptoJS.AES.encrypt(password, ENCRYPTION_KEY).toString();
  return encrypted;
};

const renderSubTotal = (cartData) => {
  let subTotal = 0;
  cartData?.map((item) => {
    let val = item.discount > 0 ? item.discount : item.price;
    subTotal = subTotal + val * item.selectedQty;
  });
  return subTotal;
};

const getDuration = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const durationMs = endDate - startDate;
  const durationMinutes = Math.floor(durationMs / 60000);
  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;
  if (hours === 0) {
    return `${minutes} mins`;
  } else {
    return `${hours} hrs : ${minutes} mins`;
  }
};

const convertMinutesToHours = (minutes) => {
  if (minutes < 0) return "Invalid input";

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  const hoursPart = hours > 0 ? `${hours} hour${hours > 1 ? "s" : ""}` : "";
  const minutesPart =
    remainingMinutes > 0
      ? `${remainingMinutes} minute${remainingMinutes > 1 ? "s" : ""}`
      : "";

  return `${hoursPart}${
    hoursPart && minutesPart ? " " : ""
  }${minutesPart}`.trim();
};

const decodeHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.documentElement.textContent;
};

export {
  encryptPassword,
  renderSubTotal,
  getDuration,
  convertMinutesToHours,
  decodeHtml,
};
